<template>
  <div id="modalEvaluationProject" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Avaliar Sumário Executivo</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="evaluationProject">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Avaliação: <span class="text-danger">*</span>
                </label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="statusRecusado"
                      value="0"
                      v-model="evaluation.status"
                    />
                    <label class="form-check-label" for="statusRecusado">
                      Recusado
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="statusReprovadoComAjustes"
                      value="3"
                      v-model="evaluation.status"
                    />
                    <label
                      class="form-check-label"
                      for="statusReprovadoComAjustes"
                    >
                      Reprovado com Ajustes
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="statusAprovado"
                      value="4"
                      v-model="evaluation.status"
                    />
                    <label class="form-check-label" for="statusAprovado">
                      Aprovado
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <label class="form-label">Observações:</label>
                <textarea
                  class="form-control"
                  :class="{
                    'is-invalid': v$.evaluation.observation.$errors.length,
                  }"
                  placeholder="Observações/Justificativas"
                  rows="8"
                  v-model="v$.evaluation.observation.$model"
                />
                <span
                  v-if="v$.evaluation.observation.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-sm btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-sm btn-success"
              title="Avaliar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Avaliar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import StatusProjectEnum from '@/enum/statusProjectEnum'

export default {
  name: 'EvaluationProjectModal',

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      evaluation: {
        status: '',
        observation: '',
      },
      disableButton: false,
    }
  },

  methods: {
    async evaluationProject() {
      this.disableButton = true
      try {
        const response = await this.$store.dispatch('evaluationProject', {
          projectId: this.projectId,
          evaluation: this.evaluation,
        })

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  validations() {
    return {
      evaluation: {
        status: {
          required,
        },
        observation: {
          required: requiredIf(() => {
            return (
              this.evaluation.status ===
                StatusProjectEnum.REPROVADO_COM_AJUSTES ||
              this.evaluation.status === StatusProjectEnum.RECUSADO
            )
          }),
        },
      },
    }
  },

  mounted() {
    showModal('modalEvaluationProject')
  },
}
</script>
